import React, { useEffect, useState, useMemo, useCallback } from 'react';
import './index.css';
import ModalService from '../../../services/ModalService';
import { DashBoardTitle } from '../../Title';
import { Col, Container, Row, Modal, ModalBody, Table } from 'reactstrap';
import { getDealerwithStatus, dealerDocumentUpload, editDealer, generatePDF } from '../../../constants/apiCalls';
import Pagination from '../../Pagination/Pagination';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import print from '../../../images/print.png';
import upload from '../../../images/fileUpload.png';
import download from '../../../images/download.png';
import closeImg from '../../../assets/img/close.png';
import { PreviewAppModal } from '../../../Pages/Registeration';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';
import { BreadCrumbBackButton } from '../../Breadcrumbs/BreadCrumbBackButton';
import { Breadcrumbs } from '../../Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import { UserFilters } from '../../Filters';
import { handleErrorMessage } from '../../../utils/utils';
import DateService from '../../../services/DateService';
import { CommonButton, FileUploadButton } from '../../CommonComponents';
import UploadDocPreview from '../../CustomModal/UploadDocPreview/UploadDocPreview';
import { messages } from '../../../utils/constant-messages';
import { Permissions } from '../../../constants/Permissions';
import { Roles } from '../../../constants/Roles';
import { UploadModal } from '../../CustomModal';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

export function ApprovedAppTable() {
  const navigate = useNavigate();
  // const localPermission = Storage.getUserPermissionDetail();
  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;
  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';
  useEffect(() => {
    if (!localPermission.includes(Permissions.APPROVED_APP)) {
      navigate('/');
    }
  }, [...localPermission])

  let pageNo = useMemo(() => Storage.getAppprovePage(), [Storage.getAppprovePage()]);

  const [isLoading, setIsloading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const [uploadModal, setUploadModal] = useState(false);
  const [docData, setDocData] = useState([]);
  const [binaryDoc, setBinaryDoc] = useState([]);

  const [modal, setModal] = useState(false);
  const [modalPreview, setModalPreview] = useState(false);
  const [object, setObject] = useState('');
  const [Id, setId] = useState('');

  // Filters
  const [dealerData, setDealerData] = useState([]);

  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(10);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [ImgUpload, setImgUpload] = useState('');
  const [isPrinting, setIsPrinting] = useState(false);
  const location = useLocation();

  let userDataAll = Storage.getBreadcrumbsrRecord();
  let userData = useMemo(
    () =>
      userDataAll.reduce((unique, o) => {
        if (!unique.some((obj) => obj.id === o.id && obj.role === o.role)) {
          if (o.filter) {
            unique.push(o.filter);
          }
        }
        return unique;
      }, []),
    []
  );

  useEffect(() => { }, [userData]);

  useEffect(() => {
    if (isPrinting) {
      window.print();
      setIsPrinting(!isPrinting);
    }
  }, [isPrinting]);

  const toggle = (e, id) => {
    setId(id);
    setModal(!modal);
  };

  const setBreadcrumbsRecord = () => {
    Storage.setBreadcrumbsrRecord([
      {
        title: 'Approved App',
        url: location.pathname,
      },
    ]);
  };

  const togglePreviewApp = (val) => {
    setBreadcrumbsRecord();
    setId(val);
    setModalPreview(!modalPreview);
  };

  const getDealerData = useCallback(
    (obj, page, pageSize) => {
      setIsloading(true);
      setObject(obj);
      let payload = {
        q: obj.searchQuery || '',
        pagesize: pageSize,
        page: page || 1,
        type: 'approve',
        pipeline_status: obj.statusId || null,
        start_date: obj.startDate ? obj.startDate : '',
        end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        is_download: false,
        adminOnly: false,
        manageDealer: false,
        application_upload: obj.uploadApp ? obj.uploadApp : '',
      };
      getDealerwithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          if (obj.uploadApp && obj.uploadApp === 'yes') {
            let activeUpoloadData = data.data.filter(
              (val) => val.application_file !== null
            );
            setDealerData(activeUpoloadData);
          } else if (obj.uploadApp && obj.uploadApp === 'no') {
            let inActiveUpoloadData = data.data.filter(
              (val) => val.application_file === null
            );
            setDealerData(inActiveUpoloadData);
          } else {
            setDealerData(data.data);
          }
          let count = data.total_count;
          setCount(count);
          let totalPages = Math.ceil(count / pageSize);
          setTotalPages(totalPages);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize]
  );

  const handleExcelSheet = useCallback(
    (obj, page, pageSize) => {
      let payload = {
        q: obj.searchQuery || '',
        pagesize: 100000,
        page: page || 1,
        type: 'approve',
        pipeline_status: obj.statusId || null,
        start_date: obj.startDate ? obj.startDate : '',
        end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        is_download: true,
        adminOnly: false,
        manageDealer: false,
        application_upload: obj.uploadApp ? obj.uploadApp : '',
      };
      getDealerwithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          window.open(data.file, '_blank');
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize]
  );

  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setAppprovePage(Number(page));
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize]
  );

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize]
  );

  const handlePrintFunction = (id) => {
    setIsloading(true);
    generatePDF((res) => {
      const { data, success, error } = res;
      if (success) {
        if (data && data.file) {
          window.open(data.file, '_blank');
        }
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, id);
    setIsloading(false);
  };

  const handleCommonUpload = (e) => {
    let fileVal = e.target.files;
    setBinaryDoc(Array.from(fileVal));
    let images = [];
    for (let i = 0; i < fileVal.length; i++) {
      images.push({ filename: fileVal[i].name, url: URL.createObjectURL(fileVal[i]), type: fileVal[i].type });
    }
    setDocData(images);
    setUploadModal(!uploadModal);
  };

  const handleChangeMoreDoc = (e) => {
    let fileVal = e.target.files;
    let newBinaryArr = binaryDoc.concat(Array.from(fileVal))
    setBinaryDoc(newBinaryArr);
    let moreImg = [];
    for (let i = 0; i < fileVal.length; i++) {
      moreImg.push({ filename: fileVal[i].name, url: URL.createObjectURL(fileVal[i]), type: fileVal[i].type });
    }
    let newDocArr = docData.concat(moreImg);
    setDocData(newDocArr);
  }

  const handleDeleteDoc = (key, index) => {
    let filterBinaryArr = [...binaryDoc];
    filterBinaryArr.splice(index, 1);
    setBinaryDoc(filterBinaryArr);

    let filterOriginalArr = [...docData];
    filterOriginalArr.splice(index, 1);
    setDocData(filterOriginalArr);
  }

  const handleUploadDoc = () => {
    let pdfDocIndex = docData.findIndex(e => e.type === 'application/pdf')
    let ImgDocIndex = docData.findIndex(e => e.type === 'image/jpeg' || e.type === 'image/png')

    if (pdfDocIndex > -1 && ImgDocIndex > -1) {
      ModalService.openAlert('', messages.COMMON.EITHER_PDF_IMAGE, 'error');
    } else if (pdfDocIndex > -1 && ImgDocIndex === -1 && docData && docData.length > 1) {
      ModalService.openAlert('', messages.COMMON.MULTIPLE_PDF, 'error');
    } else {
      let formData = new FormData();
      for (let i = 0; i < binaryDoc.length; i++) {
        formData.append('files', binaryDoc[i]);
      }
      formData.append('ownerimage', false);
      setIsloading(false);
      setIsModalLoading(true);
      dealerDocumentUpload((res) => {
        const { success, data, message, error } = res;
        if (success === true) {
          setImgUpload(data.imageUrl);
          setUploadModal(!uploadModal);
          ModalService.openAlert('', message, 'success');
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, formData);
    }
  }
  const removeSelectedImage = () => {
    setImgUpload('');
  };

  const handlePrintUpload = () => {
    setIsloading(true);
    let payload = {
      id: Id,
      application_file: ImgUpload ? ImgUpload : null,
    };
    editDealer((res) => {
      const { success, message, error } = res;
      if (success) {
        setModal(!modal);
        ModalService.openAlert('', message, 'success');
        getDealerData(object, page, pageSize);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setModal(!modal);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const handleDownload = (val) => {
    window.open(val, '_blank');
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='approveTable'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='Approved Application' />
                        <BreadCrumbBackButton />
                      </div>
                    </Col>
                    <Col xs={12}>
                      {!modalPreview && <Breadcrumbs title='Approved App.' />}
                    </Col>
                    <Col xs={12}>
                      <UserFilters
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        pageNo={pageNo}
                        userData={userData}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        dealerData={getDealerData}
                        excelData={handleExcelSheet}
                      />
                    </Col>
                  </Row>
                  {dealerData && dealerData.length > 0 ? (
                    <Row>
                      <Col xs={12}>
                        <div className='table-responsive dealerTable'>
                          <Table bordered className='table text-center'>
                            <thead>
                              <tr>
                                <th>Approval Date</th>
                                <th>Dealer Code</th>
                                <th>Dealership Name</th>
                                <th>Owner Name</th>
                                <th>Mobile</th>
                                <th>City/Town</th>
                                {roleName !== Roles.TM_NAME && <th>State</th>}
                                <th>Territory</th>
                                <th>Credit Limit</th>
                                {(roleName === Roles.TM_NAME ||
                                  roleName === Roles.SH_NAME) && <th>Last CL Set Date</th>}
                                {roleName === Roles.BH_NAME && <th>NH</th>}
                                {(roleName === Roles.NH_NAME ||
                                  roleName === Roles.BH_NAME) && <th>SH</th>}
                                <th>TM</th>
                                <th>Upload Application</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {dealerData.map((elem, index) => {
                                const {
                                  id,
                                  dealer_code,
                                  business_name,
                                  primary_contact_name,
                                  primary_contact_mobile,
                                  city,
                                  territory,
                                  nh,
                                  sh,
                                  th,
                                  state,
                                  application_file,
                                  credit_limit,
                                  last_credit_limit_set_date,
                                  approval_date,
                                } = elem;
                                return (
                                  <tr key={index}>
                                    <td>
                                      {DateService.localDateOnly(approval_date) || 'N/A'}
                                    </td>
                                    <td>{dealer_code}</td>
                                    <td>
                                      <span
                                        className='dealershipLink'
                                        onClick={() => togglePreviewApp(id)}
                                      >
                                        {business_name}
                                      </span>
                                    </td>
                                    <td>{primary_contact_name}</td>
                                    <td>{primary_contact_mobile}</td>
                                    <td>{city}</td>
                                    {roleName !== Roles.TM_NAME && <td>{state}</td>}
                                    <td>{territory}</td>
                                    <td>{credit_limit}</td>
                                    {(roleName === Roles.TM_NAME ||
                                      roleName === Roles.SH_NAME) && (
                                        <td>
                                          {last_credit_limit_set_date !== null
                                            ? moment(last_credit_limit_set_date).format(
                                              'DD-MM-YYYY'
                                            )
                                            : 'N/A'}
                                        </td>
                                      )}
                                    {roleName === Roles.BH_NAME && <td>{nh}</td>}
                                    {(roleName === Roles.NH_NAME ||
                                      roleName === Roles.BH_NAME) && <td>{sh}</td>}
                                    <td>{th}</td>
                                    <td>{application_file ? 'Yes' : 'No'}</td>
                                    <td>
                                      <div className='iconBlock'>
                                        {application_file ? (
                                          <img
                                            src={download}
                                            onClick={() =>
                                              handleDownload(application_file)
                                            }
                                            alt='download'
                                            className='iconImg'
                                          />
                                        ) : (
                                          <>
                                            <img
                                              onClick={() => handlePrintFunction(id)}
                                              src={print}
                                              alt='print'
                                              className='iconImg'
                                            />
                                            <img
                                              onClick={(e) => toggle(e, id)}
                                              src={upload}
                                              alt='upload'
                                              className='iconImg'
                                            />
                                          </>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className='paginationWrapper'>
                          <span className='page-select-title'>Rows per page:</span>
                          &nbsp;&nbsp;
                          <select
                            className='form-control rows-per-page-select'
                            name='pageSize'
                            value={pageSize}
                            onChange={(e) => handleInputChange(e)}
                          >
                            <option key='5' value='5'>
                              5 Rows
                            </option>
                            <option key='10' value='10'>
                              10 Rows
                            </option>
                            <option key='15' value='15'>
                              15 Rows
                            </option>
                            <option key='20' value='25'>
                              25 Rows
                            </option>
                            <option key='25' value='30'>
                              30 Rows
                            </option>
                            <option key='30' value='50'>
                              50 Rows
                            </option>
                          </select>
                          &nbsp;&nbsp;
                          <div className='pageList'>
                            <Pagination
                              margin={2}
                              page={page}
                              count={parseInt(totalPages)}
                              pageSize={pageSize}
                              totalRecords={parseInt(count)}
                              onPageChange={handlePageChange}
                            ></Pagination>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>
                        {messages.COMMON.NO_RECORD_MATCH}
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>

              {/* preview Modal */}
              <Modal
                id='preview-modal-approved'
                isOpen={modalPreview}
                toggle={togglePreviewApp}
                className='previewAppModal'
                centered
              >
                <ModalBody className='pl-0 pr-0'>
                  <Container fluid>
                    <Row>
                      <Col xs={12}>
                        <div className='modalHeading'>
                          <div className='title leftTitle'>Preview App</div>
                          <div className='closeButton'>
                            <img
                              src={closeImg}
                              alt='close'
                              onClick={() => setModalPreview(!modalPreview)}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <PreviewAppModal
                          userId={Id}
                          showButtons={true}
                          hideComponents={modalPreview}
                        />
                      </Col>
                    </Row>
                    <Row className='justify-content-center'>
                      <CommonButton name={'Close'} btnClass={'btnPrimary'} type="button" onClick={() => setModalPreview(!modalPreview)} />
                    </Row>
                  </Container>
                </ModalBody>
              </Modal>

              {/* Upload Doc Modal */}
              <UploadModal
                isOpen={uploadModal}
                toggle={() => setUploadModal(!uploadModal)}
                isModalLoading={isModalLoading}
                modalData={docData}
                uploadKey={null}
                handleChangeMoreDoc={handleChangeMoreDoc}
                handleDeleteDoc={handleDeleteDoc}
                handleUploadDoc={handleUploadDoc}
              />

              {/* Image Upload Modal (Preview Doc Modal) */}
              <Modal
                id='ImgUploadModal'
                isOpen={modal}
                toggle={toggle}
                className='uploadDocModal'
                centered
              >
                <ModalBody className='pl-0 pr-0'>
                  {isModalLoading && <CustomSpinner />}
                  <Container>
                    <Row>
                      <Col xs={12}>
                        <div className='modalHeading'>
                          <div className='title leftTitle'>Upload New Dealer Application</div>
                          <div className='closeButton'>
                            <img
                              src={closeImg}
                              alt='close'
                              onClick={() => setModal(!modal)}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} className='text-center'>
                        {ImgUpload && ImgUpload ? (
                          <>
                            <UploadDocPreview
                              isRemove={true}
                              uploadDocpath={ImgUpload}
                              handleRemoveClick={removeSelectedImage}
                            />
                          </>
                        ) : (
                          <FileUploadButton
                            maxWidth="150px"
                            onChange={(e) => handleCommonUpload(e)}
                            label='Select File'
                          />
                        )}
                      </Col>
                      <Col xs={12} className='text-center'>
                        <CommonButton name={'Upload'} btnClass={'btnPrimary'} type="button" disabled={!ImgUpload} onClick={handlePrintUpload} />
                      </Col>
                    </Row>
                  </Container>
                </ModalBody>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
